var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bacgroundColorsComponent"},[(_vm.label.backgroundcolors.length > 1)?_c('ul',{staticClass:"backgroundColorsItems"},_vm._l((_vm.label.backgroundcolors),function(backgroundcolor){return _c('li',{staticClass:"backgroundColorsItem cmpt",style:({ 'background-color': 'rgb('+ backgroundcolor.rgb+')'}),on:{"click":function($event){_vm.changeBackgroundColor(backgroundcolor)}}})})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8df79eca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackgroundsColors/BackgroundColors.vue
// module id = 90
// module chunks = 0